import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg">
                <i className="ri-book-read-line text-xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">酷漫屋</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              致力于为韩漫爱好者提供海量免费韩国漫画在线阅读服务，支持下拉式阅读，更新快、资源全、体验佳。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">漫画分类</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">恋爱漫画</Link>
              <Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">奇幻漫画</Link>
              <Link to="/category/action" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">动作漫画</Link>
              <Link to="/category/horror" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">恐怖漫画</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">联系与声明</h4>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              如有问题或建议，欢迎通过邮件与我们联系。
            </p>
            <a href="mailto:contact@kumanwu.com" className="text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap" rel="nofollow">
              contact@kumanwu.com
            </a>
            <p className="text-xs text-foreground-500 mt-4">
              本站所有资源均来自网络，仅供学习交流使用。
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-foreground-800/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 酷漫屋 - 版权所有
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}